import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";

const ContactUs = () => {
  const [isLoading, setIsLoading] = useState(true);

  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <div id="contactus" className="container-fluid bg-black text-white pt-5">
      <div className="container">
        <h1 className="about-heading fw-bold mb-4 text-center">Contact Us</h1>
        <div className="row">
          {/* Contact Form */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
          >
            <form>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your name"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Mobile Number</label>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Enter your mobile number"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter your message"
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn btn-danger">
                Submit
              </button>
            </form>
          </motion.div>

          {/* Company Information */}
          <motion.div
            className="col-md-6 ps-md-5 mt-4"
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
          >
            <img
              src="satiwtxt.png"
              alt="Sati Industries Logo"
              className="img-fluid mb-3"
              style={{
                maxWidth: "300px",
                height: "auto",
                backgroundColor: "white",
                borderRadius: "12px", // Rounded corners
                padding: "10px", // Some spacing between logo and white background
              }}
            />

            <p className="mb-1 mb-3">GSTIN/UIN: 26ACJFS1065Q1ZJ</p>
            <div className="d-flex justify-content-between flex-wrap">
              <div className="mb-3">
                <p className="fw-bold">
                  <FaMapMarkerAlt className="me-2" />
                  Office:
                </p>
                <p className="mb-1">
                  Gala No. 3, 4, 7, and 8, Sati Udyog Bhawan,
                </p>
                <p className="mb-1">
                  Navneet Shah Industrial Estate, Canal Road,
                </p>
                <p className="mb-1">Demni Road, D&NH DD</p>
              </div>
              <div className="mb-3">
                <p className="fw-bold">
                  <FaClock className="me-2" />
                  Timing:
                </p>
                <p>Mon-Sat 10:00 - 06:00</p>
              </div>
              <div className="mb-3">
                <p className="fw-bold">
                  <FaPhone className="me-2" />
                  Contact:
                </p>
                <p className="mb-1">+91 9879618851</p>
                <p className="mb-1">+91 7779061785</p>
              </div>
              <div className="mb-3">
                <p className="fw-bold">
                  <FaEnvelope className="me-2" />
                  Email:
                </p>
                <p className="mb-1">
                  <a href="mailto:satiind@gmail.com" className="text-white">
                    satiind@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
        <motion.div
          className="row mt-5"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <div className="col-12 position-relative">
            <div
              className="rounded-4 overflow-hidden shadow-lg w-100"
              style={{ maxWidth: "100%" }}
            >
              {isLoading && (
                <div className="d-flex justify-content-center align-items-center position-absolute w-100 h-100">
                  <div className="spinner-border text-danger" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
              <iframe
                title="Office Location"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3580.5294226486667!2d72.96524207523771!3d20.329722381150397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjDCsDE5JzQ3LjAiTiA3MsKwNTgnMDQuMSJF!5e1!3m2!1sen!2sin!4v1740415131670!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                onLoad={() => setIsLoading(false)}
              ></iframe>
            </div>
          </div>
        </motion.div>
        <hr className="text-white my-4" />
        <p className="text-center mt-3 pb-3 mb-0">
          © {new Date().getFullYear()} Sati Industries - Developed & Managed by{" "}
          <strong>Circuit Wave</strong>
        </p>
      </div>
    </div>
  );
};

export default ContactUs;
